export default __webpack_public_path__ + "static/media/multiaccount.da16f047.png";